<script setup lang="ts">
  import { computed, ref } from "vue";

  interface CarouselProps {
    icon: string;
    activeIcon?: string;
    title: string;
    desc: string;
    image: string;
  }
  const props = defineProps<{
    imagePlacement: "left" | "right";
    carousel: CarouselProps[];
    btnEmit?: (...args: any[]) => any;
  }>();
  //当前轮播图的序号
  const currentIndex = ref(0);
  // 切换面板的回调
  const beforeChange = (from: number, to: number) => {
    currentIndex.value = to;
  };
  const carouselRef = ref();
  // 切换到指定面板
  const goTo = (slideNumber: number) => {
    carouselRef.value!.goTo(slideNumber, false);
  };
  const dotOrder = computed(() => {
    return props.imagePlacement === "left" ? "order:3" : "order:1";
  });
  const onBtnClick = () => {
    props.btnEmit!();
  };
</script>

<template>
  <div class="carousel-component">
    <a-carousel ref="carouselRef" autoplay :dots="false" :before-change="beforeChange">
      <!-- <div  class="carousel-component-image"> -->
      <img v-for="(item, idx) in carousel" :key="idx" :src="item.image" />
      <!-- </div> -->
    </a-carousel>
    <div class="dot-wrapper" :style="dotOrder">
      <div
        v-for="(item, idx) in carousel"
        :key="idx"
        class="dot-item"
        :class="{ 'dot-item-active': currentIndex === idx }"
        @click="goTo(idx)">
        <icon-font v-if="item.activeIcon && currentIndex === idx" class="dot-item-icon" :type="item.activeIcon" />
        <icon-font v-else class="dot-item-icon" :type="item.icon" />
        <h4 class="dot-item-title">{{ item.title }}</h4>
        <p class="dot-item-desc">{{ item.desc }}</p>
        <div class="fot-item-btn">
          <slot name="btns"></slot>
        </div>
      </div>
      <a-button v-if="btnEmit" class="dot-btn" @click="onBtnClick">免费体验</a-button>
    </div>
  </div>
</template>

<style scoped lang="less">
  .carousel-component {
    --flex-wrap: nowrap;
    --flex-direction: row;

    display: flex;
    flex-flow: var(--flex-direction) var(--flex-wrap);
    gap: 80px;
    justify-content: center;
    max-width: 1628px;
    min-height: 672px;
    padding: 64px 0;
    margin: 0 auto;
    background: white;
    border-radius: 16px;

    @media (max-width: 1280px) {
      --flex-wrap: wrap;
      --flex-direction: column;
    }

    @media only screen and (max-width: 1440px) {
      width: min-content;
    }

    @media only screen and (max-width: 1024px) {
      padding: 24px;
    }

    :deep(.ant-carousel) {
      order: 2;
      width: 806px;
      height: min-content;
      background-color: transparent;
      border-radius: 12px;
      box-shadow: 0 4px 12px rgba(16, 62, 130, 16%);

      @media only screen and (max-width: 1024px) {
        width: calc(100vw - 90px);
        min-width: calc(320px - 90px);
      }

      .slick-slide {
        width: 806px;
        height: auto;
        padding: 16px;
        background-color: white;
        border-radius: 12px;

        @media only screen and (max-width: 1024px) {
          width: 100%;
        }

        img {
          max-width: 806px;
          max-height: 543px;
          object-fit: contain;
          border-radius: 16px;
        }
      }
    }

    .dot-wrapper {
      @media only screen and (max-width: 1280px) {
        display: flex;
        flex-direction: column;
        align-items: center;
        order: 3 !important;
      }

      .dot-item {
        display: grid;
        grid-template-areas: "icon title" "icon desc";
        grid-template-columns: 20px auto;
        gap: 16px;
        width: 515px;
        min-height: 127px;
        padding: 19px 24px;
        cursor: pointer;
        border-radius: 16px;

        @media only screen and (max-width: 480px) {
          width: 300px;
        }

        &.dot-item-active {
          background-color: white;
          border: 1px solid #2f78ff;
        }

        .dot-item-icon {
          grid-area: icon;
          height: 20px;
          font-size: 20px;
        }

        .dot-item-title {
          grid-area: title;
          font-size: 20px;
          font-weight: 600;
          line-height: 23px;
          color: #1d2129;
        }

        .dot-item-desc {
          grid-area: desc;
          font-size: 16px;
          font-weight: 400;
          line-height: 19px;
          color: #4e5969;
          text-align: justify;
        }
      }

      .dot-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 180px;
        height: 64px;
        margin-top: 48px;
        margin-left: 23px;
        font-size: 20px;
        line-height: 23px;
        color: #fff;
        background: linear-gradient(90deg, #0a5cff 0%, #54b7ff 100%);
        border-radius: 4px;
      }
    }
  }
</style>
